import { FileUIPart } from 'ai';
import { isRachelImageMediaType } from '../../../../rachel.files.presentation';

const SAFE_URL_PROTOCOLS = ['http:', 'https:'];

export const getRachelFileDisplayName = (part: FileUIPart): string => {
  if (part.filename) {
    return part.filename;
  }
  const tail = part.url.split('/').pop() ?? part.url;
  return tail.split('?')[0];
};

export const isSafeUrl = (url: string): boolean => {
  try {
    return SAFE_URL_PROTOCOLS.includes(new URL(url).protocol);
  } catch {
    return false;
  }
};

export const isRachelFileThumbnail = (part: FileUIPart): boolean =>
  isRachelImageMediaType(part.mediaType) && isSafeUrl(part.url);
